// src/services/apiMockService.ts
// Ein Service zur Bereitstellung von Mock-Daten während der Entwicklung
import { Character } from './characterService';

// Array mit Klassenemblems für Entwicklungszwecke
const classEmblems = {
  Titan: {
    emblemPath: 'https://www.bungie.net/common/destiny2_content/icons/9eb22cf91d46bf5b38197cce36c35853.jpg',
    emblemBackgroundPath: 'https://www.bungie.net/common/destiny2_content/icons/f6e0c7823fb3ebca333c369388718a01.jpg'
  },
  Hunter: {
    emblemPath: 'https://www.bungie.net/common/destiny2_content/icons/6a22ef02ea96fad7e1e2c28dc44f4adb.jpg',
    emblemBackgroundPath: 'https://www.bungie.net/common/destiny2_content/icons/93c6b204ff2d44416b44f9b2668792b2.jpg'
  },
  Warlock: {
    emblemPath: 'https://www.bungie.net/common/destiny2_content/icons/e6e30042ea47ee3d0b5ee1d9c4fed77a.jpg',
    emblemBackgroundPath: 'https://www.bungie.net/common/destiny2_content/icons/7c373426e481a5d6a3da0e4e6cc4316b.jpg'
  }
};

/**
 * Generiert Mock-Charakterdaten für die Entwicklung
 */
export const getMockCharacters = (): Character[] => {
  return [
    {
      characterId: '1234567890',
      classType: 0,
      className: 'Titan',
      race: 'Exo',
      gender: 'Male',
      light: 1345,
      emblemPath: classEmblems.Titan.emblemPath,
      emblemBackgroundPath: classEmblems.Titan.emblemBackgroundPath,
      lastPlayed: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 Tage zurück
      minutesPlayedTotal: 5240,
      level: 50
    },
    {
      characterId: '2345678901',
      classType: 1,
      className: 'Hunter',
      race: 'Awoken',
      gender: 'Female',
      light: 1350,
      emblemPath: classEmblems.Hunter.emblemPath,
      emblemBackgroundPath: classEmblems.Hunter.emblemBackgroundPath,
      lastPlayed: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), // 1 Tag zurück
      minutesPlayedTotal: 6120,
      level: 50
    },
    {
      characterId: '3456789012',
      classType: 2,
      className: 'Warlock',
      race: 'Human',
      gender: 'Male',
      light: 1342,
      emblemPath: classEmblems.Warlock.emblemPath,
      emblemBackgroundPath: classEmblems.Warlock.emblemBackgroundPath,
      lastPlayed: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 Tage zurück
      minutesPlayedTotal: 4890,
      level: 50
    }
  ];
};

/**
 * Findet einen Mock-Charakter anhand seiner ID
 * @param characterId ID des gesuchten Charakters
 */
export const getMockCharacterById = (characterId: string): Character | undefined => {
  return getMockCharacters().find(char => char.characterId === characterId);
};